import * as React from 'react';
import dechoesLightLogo from '@/assets/images/icons/dechoes_light.svg';
import rightArrow from '@/assets/images/svg/right_arrow.svg';

/** Logo + "More about us" link shown on mobile auth screens. Hidden at fold+. */
export const AuthMobileHeader: React.FC = () => (
  <>
    <img
      src={dechoesLightLogo}
      alt='d.echo'
      className='block size-auto object-contain fold:hidden'
    />
    <a
      href={import.meta.env['VITE_LANDING_URL'] || 'https://dechoes.com'}
      target='_blank'
      rel='noopener noreferrer'
      className='flex items-center font-sans text-18 font-medium leading-25 tracking-normal text-white underline decoration-solid hover:opacity-80 fold:hidden'
    >
      <img src={rightArrow} alt='' className='mr-[14px] size-auto' />
      More about us
    </a>
  </>
);
